export default __webpack_public_path__ + "static/media/5.bea0d960.png";